module.exports = __webpack_public_path__ + "img/handi-inea.360b5784.svg";